import styled from 'styled-components';
import { PositionAndSizeFromProps } from '../../utils/styledcomponents';
import type { PositionAndSizeProps } from '../../utils/styledcomponents';

export interface Props {}

const Centered = styled.div<Props>`
	display: flex;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
`;

export default styled(Centered)<PositionAndSizeProps>(PositionAndSizeFromProps);
